/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Miss, render } from '@xingternal/hops';

import reducers from './reducers';

import { initSentry } from './shared';
import XingFrame from './Frame';

import HelpSupport from './helpSupport';
import { ContactPage, SuccessPage } from './contact';
import ttt, { env } from './tracking';

ttt.init(env, { fetchTrackingData: true });
initSentry();

const withCookieConsent =
  (Component, disableBanner = false) =>
  (props) => {
    return (
      <XingFrame disableBanner={disableBanner}>
        <Component {...props} />
      </XingFrame>
    );
  };

export const App = () => {
  return (
    <Switch>
      <Route exact path="/support/contact/success" component={withCookieConsent(SuccessPage)} />
      <Route path="/support/contact/:topic?/:subject?" component={withCookieConsent(ContactPage)} />
      <Route exact path="/faq" component={withCookieConsent(HelpSupport)} />
      <Miss />
    </Switch>
  );
};

export default render(<App />, { redux: { reducers } });
